import { render, staticRenderFns } from "./DocumentMail.vue?vue&type=template&id=5ece943c&scoped=true"
import script from "./DocumentMail.vue?vue&type=script&lang=js"
export * from "./DocumentMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ece943c",
  null
  
)

export default component.exports